import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import LogInPage from '../login/LogInPage';
import Home from '../pages/Home';
import CompanyDetailPage from '../pages/CompanyDetailPage';
import CompanyPage from '../pages/CompanyPage';
import Page404 from '../pages/Page404';
import Page401 from '../pages/Page401';
import UserPage from '../pages/UserPage';
import AdminPage from '../pages/AdminPage';
import AdminUsersPage from '../pages/AdminUsersPage';
import AdminStateGroupPage from '../pages/AdminStateGroupPage';
import AdminStateGroupDetailPage from '../pages/AdminStateGroupDetailPage';
import PersonDetailPage from '../pages/PersonDetailPage';
import UserDetailPage from '../pages/UserDetailPage';
import AdminUsersDetailPage from '../pages/AdminUsersDetailPage';
import RegionalUserDetailPage from '../pages/RegionalUserDetailPage';
import RegionalCompanyDetailPage from '../pages/RegionalCompanyDetailPage';
import RegionalCompanyUserDetailPage from '../pages/RegionalCompanyUserDetailPage';
import AdminAttributesPage from '../pages/AdminAttributesPage';
import AdminActionplanPage from '../pages/AdminActionplanPage';
import ProgramNewPage from '../pages/ProgramNewPage';
import ProgramDetailPage from '../pages/ProgramDetailPage';
import ProgramGoalPage from '../pages/ProgramGoalPage';
import ProgramGoalPageCustomerResult from '../pages/ProgramGoalPageCustomerResult';
import ProgramPage from '../pages/ProgramPage';
import ProgramGoalRefundPage from '../pages/ProgramGoalRefundPage';
import ProgramGoalUserPage from '../pages/ProgramGoalUserPage';
import UploadPage from '../pages/UploadPage';
import ProgramGoalsPage from '../pages/ProgramGoalsPage';
import PasswordPage from '../pages/PasswordPage'; 
import ProgramGoalActionPlanPage from '../pages/ProgramGoalActionPlanPage';
import HowtoPage from '../pages/HowtoPage';
import ProgramGoalQAwardPage from '../pages/ProgramGoalQAwardPage';
import ProvidersPage from '../pages/ProvidersPage';
import ProviderDetailPage from '../pages/ProviderDetailPage';
import ProviderUserPage from '../pages/ProviderUserPage';
import LgpdAcceptPage from '../pages/LgpdAcceptPage';
import LgpdReportPage from '../pages/LgpdReportPage';

export default class Routes extends React.Component {

    static NotFound = Page404;
    static NotAllowed = Page401;
    static Login = LogInPage;
    static MyUser = UserPage;

    static Pages = [
        UserPage,
        PasswordPage,
        ProgramPage, ProgramNewPage, ProgramDetailPage, ProgramGoalsPage, ProgramGoalPage, ProgramGoalPageCustomerResult, ProgramGoalQAwardPage, ProgramGoalRefundPage, ProgramGoalUserPage,
        CompanyPage, CompanyDetailPage, UserDetailPage,
        PersonDetailPage,
        AdminPage, AdminAttributesPage, AdminActionplanPage, UploadPage, 
        AdminStateGroupPage, AdminStateGroupDetailPage, RegionalUserDetailPage, RegionalCompanyDetailPage, RegionalCompanyUserDetailPage, ProvidersPage, ProviderDetailPage, ProviderUserPage,
        AdminUsersPage, AdminUsersDetailPage,
        HowtoPage,
        LgpdAcceptPage,
        LgpdReportPage,
        Page404
    ];

    static Home = [
        // ProgramPage
        Home
    ];

    static CheckRoute(item) {
        var v = global.user;
        var w = global.permissions;
        if (typeof item.PageInfo !== "undefined") {
            if (typeof item.PageInfo.access === "object" &&
                item.PageInfo.access != null &&
                (v == null || (item.PageInfo.access[v.personType.keyConstant] != true)))
                return v == null ? Routes.Login : Routes.NotAllowed;

            if (typeof item.PageInfo.permission === "object" &&
                item.PageInfo.permission != null) {
                var valid = true;
                for (var i in item.PageInfo.permission)
                    if (item.PageInfo.permission[i] == true) valid = false;
                if (w != null)
                    for (var i in w)
                        if (item.PageInfo.permission[i] == true) {
                            valid = true;
                        } else if (item.PageInfo.permission[i] == false) {
                            valid = false;
                            break;
                        }
                if (!valid)
                    return v == null ? Routes.Login : Routes.NotAllowed;
            }
        }

        return null;
    }

    static getChildren(target) {
        var c = [];
        for (let i = 0; i < Routes.Pages.length; i++)
            if (typeof Routes.Pages[i].PageInfo.parent !== "undefined")
                if (Routes.Pages[i].PageInfo.parent == target)
                    c.push(Routes.Pages[i]);
        c.sort(Routes.compare);
        return c;
    }

    static compare(a, b) {
        if (a[0] < b[0]) {
            return -1;
        }
        if (a[0] > b[0]) {
            return 1;
        }
        return 0;
    }


    renderRoute(item, path) {
        var c = Routes.CheckRoute(item);
        if (c == null) c = item;
        return <Route exact={item.PageInfo.path != "*"} path={path} component={c} />;
    }

    static GetHome() {
        for (let i = 0; i < Routes.Home.length; i++)
            if (Routes.CheckRoute(Routes.Home[i]) == null)
                return Routes.Home[i];

        return Routes.Login;
    }

    render() {
        return (
            <Switch>
                {<Route exact={true} path="/" component={Routes.GetHome()} />}
                {Routes.Pages.map((item) => {
                    if (typeof item.PageInfo === "object") {
                        var r = typeof item.PageInfo.path === "string" ? [item.PageInfo.path] :
                            Array.isArray(item.PageInfo.parent) ? item.PageInfo.path : [];
                        if (r.length > 0)
                            return r.map((item2) => this.renderRoute(item, item2));
                    }
                    return null;
                })}
            </Switch>
        );
    }
}  